import { GearSix, X } from "@phosphor-icons/react";

import { INTEGRATIONS_MAP } from "features/integrations/constants";
import type { IntegrationSettings } from "features/integrations/types";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerContent,
  DrawerHeader,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "common/components/ui/Popover";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import type { ReactNode } from "react";

interface SettingsContainerProps {
  integrationKey: keyof IntegrationSettings;
  children: ReactNode;
  isOpen?: boolean;
  setIsOpen?: (isOpen: boolean) => void;
}

export default function SettingsContainer(props: SettingsContainerProps) {
  const { integrationKey, children, isOpen, setIsOpen } = props;

  const isDesktop = useTwBreakpoint("lg");

  const { title } = INTEGRATIONS_MAP[integrationKey];

  const Component = isDesktop ? Popover : Drawer;
  const Trigger = isDesktop ? PopoverTrigger : DrawerTrigger;
  const Content = isDesktop ? PopoverContent : DrawerContent;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Trigger asChild>
        <Button variant="secondary-black" intent="iconOnly" size="sm">
          <GearSix />
        </Button>
      </Trigger>

      <Content className="lg:w-96" align="start">
        {isDesktop ? (
          <div className="p-4 flex items-center border-b border-b-black-200 justify-between">
            <h3 className="text-md-bold">{title} settings</h3>

            <PopoverClose>
              <X className="text-black-500 size-5" />
            </PopoverClose>
          </div>
        ) : (
          <DrawerHeader title={<>{title} settings</>} />
        )}

        {children}
      </Content>
    </Component>
  );
}
